export default __webpack_public_path__ + "static/media/profileImg10.b275fce2.png";